import AbstractFilterDefinition from './AbstractFilterDefinition.js'

export default class BooleanFilterDefinition extends AbstractFilterDefinition
{
    constructor(name, label, options) {
        super(name, label);
        this.options = options;
    }

    get component() {
        return 'boolean-filter';
    }

    dataAdapter(data) {
        return data.value === 'Y' ? true : false;
    }

    get configuration() {
        const defaultOptions = {
            'Y' : {
                'value': 'Y',
                'label': i18n.__("Oui")
            },
            'N' : {
                'value': 'N',
                'label': i18n.__("Non")
            }
        };

        let options = typeof this.options == 'function' ? this.options() : defaultOptions;

        return {
            "value": {
                "name": "value",
                "type": "radio",
                "options": options
            },
        };
    }
}